export default "__VITE_ASSET__DbUW$0tZ__"